import React, {Component} from "react";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {EditPhoneBookName, EditPhoneBookExternalNum, EditPhoneBookMemo, 
    ViewCallHistoryList} from "../Elements/AscElements/PhoneBookElements";

export default class PhoneBookUpdateModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
                getTimeAgo={this.props.getTimeAgo}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PhoneBookInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <EditPhoneBookName
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            charaLimit={this.props.charaLimit}
                        />
                        <EditPhoneBookExternalNum
                            state={this.props.state}
                            langText={this.props.langText}
                            onMultiSelectChange_External={this.props.onMultiSelectChange_External}
                        />
                        <EditPhoneBookMemo
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit={this.props.onTextChange_Limit}
                            charaLimit={this.props.charaLimit}
                        />
                        <ViewCallHistoryList
                            state={this.props.state}
                            langText={this.props.langText}
                            getTimeAgo={this.props.getTimeAgo}
                            onPlayAudio={this.props.onPlayAudio}
                        />
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
} 